import i18n from 'i18n';
import { TableCellHeaderProps } from 'components/TableItems/interfaces';

const headers: Array<TableCellHeaderProps> = [
  {
    order: true,
    key: 'app_name',
    i18n: i18n.t('NAME_KEY'),
  },
  {
    order: true,
    key: 'app_code',
    i18n: i18n.t('CODE_KEY'),
    style: { width: 60 },
    centerTitle: true,
  },
];

export default headers;
